export enum RetainedFilters {
    All = 'all',
    Partial = 'partial',
    None = 'none',
}
